import type { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import { set } from '../../../store/Opportunity/ProjectSource';

function ProjectSource() {
  const dispatch = useDispatch();
  const projectSourceState = useSelector((state: RootState) => state.opportunity.projectSource);

  const changeHandler = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
    dispatch(set({ [e.target.name]: e.target.value }));
  };

  return (
    <>
      <h2 className='mt-0 text-primaryColor-normal'>Project Source</h2>
      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Debt</label>
        <input
          type='number'
          name='debt'
          value={projectSourceState.debt === 0 ? '' : projectSourceState.debt}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Equity</label>
        <input
          type='number'
          name='equity'
          value={projectSourceState.equity === 0 ? '' : projectSourceState.equity}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Other</label>
        <input
          type='number'
          name='other'
          value={projectSourceState.other === 0 ? '' : projectSourceState.other}
          className='form-input'
          onChange={changeHandler}
        />
      </div>
    </>
  );
}

export default ProjectSource;
